import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { enterprisePath } from './enterprisePath';
import { Button } from 'components/ui/button';
import { enterpriseService } from 'services/enterpriseService';
import { useEnterpriseSession } from './useEnterpriseSession';

export default function EnterpriseDiscovery() {
  const { ready: apiReady, identity } = useEnterpriseSession();
  const [state, setState] = useState({ accounts: [], authorities: [] });
  useEffect(() => {
    let active = true;
    setState({ accounts: [], authorities: [] });
    if (apiReady)
      Promise.allSettled([
        enterpriseService.discoverAccounts(),
        enterpriseService.authorizations(),
      ]).then(([a, b]) => {
        if (active)
          setState({
            identity,
            accounts: a.status === 'fulfilled' ? a.value.accounts : [],
            authorities: b.status === 'fulfilled' ? b.value : [],
          });
      });
    return () => {
      active = false;
    };
  }, [apiReady, identity]);
  if (!apiReady || state.identity !== identity) return null;
  const account = state.accounts[0];
  const hasAuthorizations = state.authorities.length > 0;
  if (!account && !hasAuthorizations) return null;

  return (
    <nav className="mb-5 flex flex-wrap gap-3" aria-label="Acceso empresarial">
      {account && (
        <Button variant="secondary" asChild>
          <Link to={enterprisePath('/enterprise/empresas', account.id)}>
            Cuenta empresarial
          </Link>
        </Button>
      )}
      {hasAuthorizations && (
        <Button variant="secondary" asChild>
          <Link to="/enterprise-authorizations">
            Autorizaciones empresariales
          </Link>
        </Button>
      )}
    </nav>
  );
}
